module.exports = __webpack_public_path__ + "static/media/salesforce-integration@2x.f475463b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/salesforce-integration@2x.png
// module id = 595
// module chunks = 1